import * as React from 'react';

import Chip from '@material-ui/core/Chip';
import Tooltip from '@material-ui/core/Tooltip';

const SITUACOES = {
  usado: { label: 'Usado', cor: '#4caf50', dica: 'Há compra cadastrada com a chave da NF-e' },
  parcial: {
    label: 'Parcial',
    cor: '#fb8c00',
    dica: 'Só algumas NF-es do descarrego têm compra cadastrada',
  },
  nao_usado: {
    label: 'Não usado',
    cor: '#9e9e9e',
    dica: 'Nenhuma compra cadastrada com a chave da NF-e',
  },
};

// situação do descarrego em relação às compras (`uso_compra` vem do servidor na listagem)
const CompraField = ({ record }) => {
  const situacao = SITUACOES[record && record.uso_compra] || SITUACOES.nao_usado;

  return (
    <Tooltip title={situacao.dica}>
      <Chip
        size="small"
        label={situacao.label}
        style={{ backgroundColor: situacao.cor, color: 'white', fontWeight: 'bold' }}
      />
    </Tooltip>
  );
};

export default CompraField;
